import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { TudigoError, TudigoResponse } from "@tudigo-monorepo/core-tudigo-api";
import { HelperArticle } from "@tudigo-monorepo/core-tudigo-api-models";
import { QUERY_KEYS } from "@tudigo-monorepo/core-tudigo-utils";

import { getApiClient } from "../../../index";

type CreateHelperArticleFeedbackParams = {
  id: string;
  value: number;
  helper_article: {
    id: string;
  };
  user: {
    id: string;
  };
};

export const createHelperArticleFeedback = async (
  helperArticleId: string,
  params: CreateHelperArticleFeedbackParams,
) => {
  const apiClient = getApiClient();
  const response =
    await apiClient.apiV1.helperArticles.createHelperArticleFeedback(
      helperArticleId,
      params,
    );

  return response.data;
};

export const useCreateHelperArticleFeedbackMutation = (
  options?: UseMutationOptions<
    TudigoResponse<HelperArticle>,
    TudigoError,
    CreateHelperArticleFeedbackParams
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: (params) => createHelperArticleFeedback(params.id, params),
    onSuccess: async (...props) => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.HELPER_ARTICLES],
      });
      options?.onSuccess?.(...props);
    },
  });
};
